'use strict';

function spaceSplit(str) {
  return str.split(' ');
}
module.exports = spaceSplit;